export enum LocalStorageKeys {
	access_token = 'access_token',
	auth_token = 'auth_token',
	security_code = 'security_code',
	device_id_storage_prefix = 'pwcs_device_id',
	process_tab_guard_prefix = 'pwcs_active_process',
	process_tab_id_session_key = 'pwcs_tab_id',
}

export enum DeviceIdResolutionSource {
	Memory = 'memory',
	LocalStorage = 'localStorage',
	Thumbmark = 'thumbmark',
	Fallback = 'fallback',
}
interface ILifeTestOperationInt {
	old: { token: string; operation: string };
	new: { token: string; operation: string };
	finishTests: { token: string; operation: string };
}

export type TwoFactorChannel = 'sms' | 'whatsapp';

export type TwoFactorType = TwoFactorChannel;

/** Código de error cuando el backend exige completar 2FA antes de continuar. */
export const TWO_FACTOR_PENDING_ERROR_CODE = 2102;

/** Límite de envíos `tfa/send` alcanzado (proceso cancelado en backend). */
export const TWO_FACTOR_SEND_LIMIT_ERROR_CODE = 2105;

/** Proceso terminado o caducado (`ValidateJwt` / `sendTfa` NIF-892). */
export const PROCESS_FINISHED_ERROR_CODE = 1005;

/** Respuesta de POST `tfa/send`. */
export interface ITfaSendResponse {
	tfa_id: string;
	expires_in?: number;
}

/** Cuerpo de POST `tfa/sms-code`. */
export interface ITfaSmsCodeBody {
	otp: string;
}

/** Respuesta de POST `tfa/sms-code` (p. ej. `result`/`error` o `valid`/`expired`). */
export interface ITfaSmsCodeResponse {
	result?: string;
	error?: { error_code?: number; msg?: string };
	valid?: boolean;
	expired?: boolean;
}

/** HTTP 200 con negocio rechazado: no cerrar el modal ni emitir `verified`. */
export function isTfaSmsCodeRejected(res: unknown): boolean {
	if (res === null || res === undefined || typeof res !== 'object') {
		return false;
	}
	const r = res as Record<string, unknown>;
	if (r['valid'] === false) {
		return true;
	}
	const result = r['result'];
	if (typeof result === 'string' && result.toLowerCase() === 'ko') {
		return true;
	}
	return false;
}

/** Respuesta de GET `tfa/:tfaId/completed` (polling WhatsApp). */
export interface ITfaCompletedResponse {
	completed?: boolean;
	expired?: boolean;
	/** Tras fallback por webhook (WA no entregable), el backend puede indicar SMS. */
	type?: TwoFactorChannel;
	converted_to_sms?: boolean;
}

export const operations: ILifeTestOperationInt = {
	old: {
		token: 'dUVsVXBhMHNIM2hZY3d6b2Q4N0krakxwNi92dHZ0ZXFEWTR5eVVheHVMREpOd2dFM1dtQWRkRHJTbjY2QWVjakptM2QvbWlucUdmVEpuOEQ1cFNVS2Q5Smd3enRlbUo2K3ZrN0o0OFo4cDJQSDM4V3ZLMXo5U1gzMDZFcncrRTZpUkk2QlJ5ODB0eXNJTDdGU3dVb3JWZUJXYS9DdDNiM0lERDIyM3o1TW9ua2l3aitvUEl1UEdNRSsvUjRIRzQ4Rk1WU2NCOW1aTVpJT2d4N09nYXJqQTEyVklRMDZISTN5SlI5WTlpemhUOWxXUnV1dFpBMkdlNldZc0Z6azZnallSVGFaKzRMTHdxczIzRmMyUUtiOHY1MHdpZFp0VkhWd00yS2p5VmN0OXdsU2loZzJVdWFEd2FRTGNLR2I1WnJyZU40M3lqbE5WTWgyUy9rNzhMdnQwSWdvZFEySkk3MFJ1d2lwSE80V0d1Uy9Ick81akF4cEtIbCtodEgxRVFCNXphRnVUazJOSkU4MWtHMTRCL21tcGpRT2ZDUFVZNnFUQ2lzTGE3R25ZVzJiZFFzTE1pUFEzdWdGbWVhWllBMDFzb1ExVDF2SHJnK0RlclVIczg4Snp1Zk1DTXlYZDRoL2NQQkdMaVZMenllMWRadUp2Yyt1U2xRTHlMdENMOHc=',
		operation: '6627a331f60ab9000c24a203',
	},
	new: {
		token: 'dUVsVXBhMHNIM2hZY3d6b2Q4N0krakxwNi92dHZ0ZXFEWTR5eVVheHVMQ1B0VEZhelJybVg1dHlPZVBlRVh3aWFWdFBjODAzNDFFZHo5UHNXMjU1Ry9HM3BZTWI4bUs1NTRaa0M2YUFTTEhjTlhweHB3M1VHN3FoU0FGL0w3U0ZlU0JERDkyTVd1ejN3dlpWNzdQVGloS3NBKzBBb0UxRk9ic1ZzSmlvcHV5WENtcmUrSkZmN2J5MVVqQ2NWM0YxUCtqVUo3bGFSWUVPZy9jSHQ4S2QrRXJDbjdmSzV6NHZ3cDU1WmRFSEJsOEFTTkRhRXpZR3Rna2FYNk1WUHprQWEyVVlwR0J1dEhlK1BIL3pERVdROEhMcFFvb2lvbGdqR3Ayc2NQSWdWZVROTEpaeFlld2J1RWpaZjNWclZYYmdicC9Qbjdlc3VVOTZwSjdrTWJvd0pkZ0dwSHN3a1ZxcWRJemRUb3lXSUNxYi9pcWwzODA4K0FnTkxYMVFIQjIxYmNsYUUxa3BrMjc3QURTWHRxN2JOdz09',
		operation: '6732f3c309aad9000f2a8582',
	},
	finishTests: {
		token: 'dUVsVXBhMHNIM2hZY3d6b2Q4N0krakxwNi92dHZ0ZXFEWTR5eVVheHVMREpOd2dFM1dtQWRkRHJTbjY2QWVjakptM2QvbWlucUdmVEpuOEQ1cFNVS2ZydFJYL0Y5UFZIbjVpM0dsRXBoK0VlRzRIVFpDQ0ZqdHlHNTF5d3NFcnJrbUt6RGtCRnVGbytYd2RKd1ZDY0g5b1NLWkF1RDdmYWs2OHoxVE94V1ZqbW5jWDMyQWVPRlZNLzFoOUdxL2ZwbXNVelAzYW1mb3JMVWNXdG1LamZudjh2ZFdiWUhCUW4zVEl1bFZPVDE0RGZVVzJ0elJ2bVZYbEV4Rm9qdlJNYzQzZTZSWVUraWpDN0ZmeFVJekR0Q1J3UnFGYU9kMEY4d3lzS1BtM200b2JLd051TDBKbXZTNHNjMzZLRW9qeEdEcElIcHYxV3pVVWlRYXJ6RU04RUVKdXFDRGM3c0JvVkJYOUVtd1JjN1JuZFBlcDZXQ1JEYm9VenFYM3ZKZDhvRWl3YnJiUkM2VGhVQ1dvaVNwRHVEWXNUVmZISDQ4MmRDZzVGaXpFM05VenFGbEtSZmVKOHEyV293LzRnWlZxOTBzbzcxT3lqdG5kODRRZ0VqOXpTS250WW1RWFFja1h2bVpwN2owa1RhQVhKYzRQTzhKN05vUk94a0NNdUNTU1E=',
		operation: '',
	},
};
